 import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import HomeView from '../views/dashboard/HomeView.vue'
import UserLogin from '../views/login/UserLogin.vue'
import FormularioRegistrarse from '../views/login/FormularioRegistrarse .vue'
import EditUser from '../views/administracion/EditUser.vue'
import AgregarUsuario from '../views/administracion/AgregarUsuario.vue'
import PublicMenu from '../views/menu/PublicMenu.vue'
import MenuAdmin from '../views/menu/MenuAdmin.vue'
import RecipeBrowser from '../views/menu/RecipeBrowser.vue'
import WalletView from '../views/wallet/WalletView.vue'
import LoyaltySettings from '../views/configuracion/LoyaltySettings.vue'
import TicketClaimView from '../views/loyalty/TicketClaimView.vue'

const DEFAULT_TITLE = 'Juliam Arcade'

const routes = [
  {
    path: '/',
    redirect: '/menu'
  },
  {
    path: '/menu',
    name: 'MenuPublico',
    component: PublicMenu,
    meta: { title: 'Menú digital | Juliam Arcade' }
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin,
    meta: { title: 'Iniciar sesión | Juliam Arcade' }
  },
  {
    path: '/registrarse/:clave?',
    name: 'FormularioRegistrarse',
    component: FormularioRegistrarse,
    props: route => ({ claveProp: route.params.clave }),
    meta: { title: 'Registrarse | Juliam Arcade' }
  },
  {
    path: '/puntos/ticket/:ticketUuid',
    name: 'TicketClaim',
    component: TicketClaimView,
    props: true,
    meta: { title: 'Reclamar puntos | Juliam Arcade' }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: WalletView,
    meta: {
      title: 'Wallet | Juliam Arcade',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'UserDashboard',
    component: HomeView,
    meta: {
      title: 'Dashboard | Juliam Arcade',
      requiresAuth: true
    }
  },
  {
    path: '/catalogo',
    name: 'MenuAdmin',
    component: MenuAdmin,
    meta: {
      title: 'Catálogo | Juliam Arcade',
      requiresAuth: true,
      roles: ['administrador', 'superadministrador']
    }
  },
  {
    path: '/configuracion/lealtad',
    name: 'LoyaltySettings',
    component: LoyaltySettings,
    meta: {
      title: 'Lealtad | Juliam Arcade',
      requiresAuth: true,
      roles: ['administrador', 'superadministrador']
    }
  },
  {
    path: '/recetas',
    name: 'RecipeBrowser',
    component: RecipeBrowser,
    meta: {
      title: 'Recetas | Juliam Arcade',
      requiresAuth: true,
      roles: ['administrador', 'superadministrador']
    }
  },
  {
    path: '/dashboard/user/edit/:token',
    name: 'EditUser',
    component: EditUser,
    props: true,
    meta: {
      title: 'Editar usuario | Juliam Arcade',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard/usuarios/agregar-usuario',
    name: 'AgregarUsuario',
    component: AgregarUsuario,
    props: true,
    meta: {
      title: 'Agregar usuario | Juliam Arcade',
      requiresAuth: true
    }
  },
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: () => import('@/views/Usuarios/UsersPage.vue'),
    meta: {
      title: 'Usuarios | Juliam Arcade',
      requiresAuth: true,
      roles: ['superadministrador', 'administrador']
    }
  },
  {
    path: '/prohibido',
    name: 'Prohibido',
    component: () => import('../views/VistaProhibida.vue'),
    meta: { title: 'Acceso prohibido | Juliam Arcade' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/menu'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const user = store.state.user

  if (requiresAuth && (!user || !user.token)) return next('/login')

  const requiredRoles = to.meta && to.meta.roles
  if (!requiredRoles || !requiredRoles.length) return next()

  if (!store.state.roleLoaded) {
    try {
      await store.dispatch('fetchRole')
    } catch (error) {
      // no role means no permission
    }
  }

  const currentRole = store.state.role
  const allowed = requiredRoles.includes(currentRole)

  if (!allowed) return next('/prohibido')
  return next()
})

router.afterEach((to) => {
  const nearestRouteWithTitle = [...to.matched]
    .reverse()
    .find(route => route.meta && route.meta.title)

  document.title = nearestRouteWithTitle
    ? nearestRouteWithTitle.meta.title
    : DEFAULT_TITLE
})

export default router
